import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
  CartAddEntryFailEvent,
  CmsConfig,
  ProductLoadingService,
  provideConfig,
  RoutingConfig,
} from 'haba-core';
import { customProductUrlMatcher } from './custom-url/custom-url.matcher';
import { HabaProductLoadingService } from './haba-product-loading.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    {
      provide: ProductLoadingService,
      useClass: HabaProductLoadingService,
    },
    provideConfig(<CmsConfig>{
      featureModules: {
        HabaProductModule: {
          module: () => import('./haba-product.module').then((m) => m.HabaProductModule),
          cmsComponents: [
            'ProductImagesComponent',
            'ProductSummaryComponent',
            'ProductVariantSelectorComponent',
            'ProductIntroComponent',
            'ConfigureProductComponent',
            'ProductReferencesComponent',
            'StockNotificationComponent',
            'BreadcrumbComponent',
          ],
        },
        HabaProductTabsModule: {
          module: () =>
            import('./product-tabs/product-tabs.module').then((m) => m.ProductTabsModule),
          cmsComponents: [
            'ProductDetailsTabComponent',
            'ProductHintsTabComponent',
            'ProductReviewsTabComponent',
            'ProductCertificatesTabComponent',
            'ProductSizeTabComponent',
            'ProductQuestionsTabComponent',
            'ProductPdfsTabComponent',
          ],
        },
        ProductCardBaseModule: {
          module: () =>
            import('./product-card-base/product-card-base.module').then(
              (m) => m.ProductCardBaseModule
            ),
        },
      },
    }),
    provideConfig(<RoutingConfig>{
      routing: {
        routes: {
          product: {
            matchers: [customProductUrlMatcher],
            paths: ['p/:customProductUrl'],
          },
        },
      },
    }),
  ],
})
export class ProductFeatureModule {}
